import React, { useState } from 'react';
import './App.css';
import ChemDraw from './Elements/ChemDraw';
import ControlPanel from './Elements/ControlPanel';
import GenerateAnalogsComponent from './Elements/GenerateAnalogsComponent';
import MolecularForm from './Elements/MolecularForm';
import FragmentComponent from './Elements/FragmentComponent';
import axios from 'axios';

function App() {
  const [constantFragment, setConstantFragment] = useState('');
  const [variableFragment, setVariableFragment] = useState('');
  const [attachmentOrder, setAttachmentOrder] = useState('');
  const [jsonData, setJsonData] = useState([]);
  

  const [smiles, setSmiles] = useState('c1ccc(Cl)cc1');
  const handleSmilesChange = (newSmiles) => {
    setSmiles(newSmiles);
  };

  const handleSetSmiles = () => {
    const ketcher = window.frames[0].ketcher;
    console.log("Set SMILES clicked");
    // Implement the logic to get SMILES from ChemDraw
    
    if (ketcher) {
        ketcher.setMolecule(smiles); // 例如设置苯环分子
    } else {
        console.log('Ketcher is not ready');
    }
  };

  const handleGetSmiles = () => {
    const ketcher = window.frames[0].ketcher;
    console.log("Get SMILES clicked");
    // Implement the logic to set SMILES to ChemDraw
    
    
    if (ketcher) {
        ketcher.getSmiles().then(smiles => {
            document.getElementById('inputSmiles').value = smiles;
        }).catch(err => {
            console.log('Error getting molecule:', err);
        });
    } else {
        console.log('Ketcher is not ready');
    }
  };

  const handleFragmentize = () => {
    console.log("Fragmentize molecule clicked");
  
    const apiUrl = `/api/clm/fragmentize/?smiles=${smiles}`;
    console.log("API URL:", apiUrl);
    
    axios.get(apiUrl)
      .then(response => {
        const fragments = response.data.fragments;
        
        if (fragments && fragments.length > 0) {
          const fragment = fragments[0];

          setVariableFragment(fragment.variable_smiles.slice(1));
          setConstantFragment(fragment.constant_smiles.slice(1));
          setAttachmentOrder(fragment.attachment_order.toString());
          
          console.log("Fragment data updated", fragment);
        } else {
          console.error("No fragments found in response.");
        }
      })
      .catch(error => {
        console.error('Error fragmentizing molecule:', error);
      });
  };
  

  const handleGenerate = async(data) => {
    console.log("data", data);
    axios.post(`/api/clm/generate`, JSON.stringify(data),{
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(response => {
        setJsonData(response.data);
      })
      .catch(error => {
        console.error('Error posting data:', error);
      });
    
  };

  

  return (
    <div className="App">
      <header>
        <h1>Fragment Optimization Tools</h1>
      </header>
      <div className="container">
        <div className="ChemDraw">
          <ChemDraw />
        </div>
        <div className="ControlPanel">
          <ControlPanel
            smiles={smiles}
            onSmilesChange={handleSmilesChange}
            onGetSmiles={handleGetSmiles}
            onSetSmiles={handleSetSmiles}
            onFragmentize={handleFragmentize}
          />
        </div>
        <div className="FragmentComponent">
          <FragmentComponent 
            constantFragment={constantFragment} 
            variableFragment={variableFragment} 
            attachmentOrder={attachmentOrder} 
          />
        </div>
        <div className="GenerateAnalogsComponent">
          <GenerateAnalogsComponent 
            onGenerate={handleGenerate}
            constantSmiles = {constantFragment}
            variableSmiles = {variableFragment}
          />
        </div>
        <div className="MolecularForm">
          <MolecularForm jsonData={jsonData} />
        </div>
      </div>
    </div>
  );
}

export default App;

